import React, { useState, useEffect, useRef } from 'react';
import { Send, X, MessageSquare, User, Headphones } from 'lucide-react';
import { auth } from '../firebase';
import axios from 'axios';

const ChatModal = ({ ticket, isViewOnly, onClose, userType = 'user' }) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const messagesEndRef = useRef(null);
    const user = auth.currentUser;

     const API_BASE_URL = 'https://ufb-1.onrender.com/ticket';

    useEffect(() => {
        if (ticket) {
            fetchMessages();
            // Set up polling for real-time updates every 3 seconds
            const interval = setInterval(fetchMessages, 3000);
            return () => clearInterval(interval);
        }
    }, [ticket]);

    // useEffect(() => {
    //     scrollToBottom();
    // }, [messages]);

    // const scrollToBottom = () => {
    //     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    // };

    const fetchMessages = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/tickets/${ticket.ticketId}/chat`);
            if (response.data.success) {
                setMessages(response.data.data.messages || []);
            }
        } catch (error) {
            console.error('Error fetching messages:', error);
        } finally {
            setLoading(false);
        }
    };


const sendMessage = async (e) => {
    e.preventDefault();
    if ((!newMessage.trim() && !selectedFile) || sending) return;

    try {
        setSending(true);
        
        const formData = new FormData();
        formData.append('message', newMessage || '');
        formData.append('senderId', userType === 'user' ? user.uid : 'admin');
        formData.append('senderName', userType === 'user' ? (user.displayName || user.email) : 'Support Team');
        formData.append('senderType', userType);
        
        if (selectedFile) {
            formData.append('attachedFile', selectedFile);
        }

        const response = await axios.post(`${API_BASE_URL}/api/tickets/${ticket.ticketId}/chat`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.data.success) {
            setNewMessage('');
            setSelectedFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            fetchMessages(); // Refresh messages
        }
    } catch (error) {
        console.error('Error sending message:', error);
        alert('Failed to send message. Please try again.');
    } finally {
        setSending(false);
    }
};

    const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
        alert('File size must be less than 10MB');
        return;
    }
    
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif', 'application/pdf',
        'text/plain', 'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'video/mp4', 'video/webm', 'audio/mp3', 'audio/wav'
    ];
    
    if (!allowedTypes.includes(file.type)) {
        alert('File type not supported');
        return;
    }
    
    setSelectedFile(file);
};

const removeSelectedFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
        fileInputRef.current.value = '';
    }
};

    const formatDate = (input) => {
  if (!input) return 'N/A';

  let date;

  if (typeof input.toDate === 'function') {
    // Firestore Timestamp
    date = input.toDate();
  } else {
    // ISO string, millis, or Date
    date = new Date(input);
  }

  if (isNaN(date)) return 'N/A';

  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).replace(',', ''); // → "18 Aug 2025 05:00 PM"
};


    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl h-[600px] flex flex-col mx-4">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b bg-gray-50 rounded-t-lg">
                    <div className="flex items-center space-x-3">
                        <MessageSquare className="w-5 h-5 text-blue-600" />
                        <div>
                            <h2 className="text-lg font-semibold text-gray-900">
                                {isViewOnly ? 'Conversation History' : 'Support Chat'}
                            </h2>
                            <p className="text-sm text-gray-600">
                                Ticket: {ticket.ticketId}  • Order: {ticket.orderIdOrAwb} • {ticket.category}
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 p-1"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Messages Container */}
                <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-50">
                    {loading ? (
                        <div className="flex items-center justify-center h-full">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                        </div>
                    ) : (
                        <>
                            {/* Initial ticket info */}
                           {/* <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg">
    <div className="flex items-start">
        <MessageSquare className="w-5 h-5 text-blue-600 mt-0.5 mr-3" />
        <div className="flex-1">
            <p className="text-sm font-medium text-blue-900">Original Issue</p>
            <p className="text-sm text-blue-800 mt-1">{ticket.comment}</p>
            <p className="text-xs text-blue-600 mt-2">
                Order: {ticket.orderIdOrAwb}
            </p>
            {ticket.attachedFileUrl && (
                <div className="mt-2">
                    <a 
                        href={ticket.attachedFileUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-xs text-blue-700 hover:text-blue-900 flex items-center"
                    >
                        📎 {ticket.attachedFileName || 'View Attachment'}
                    </a>
                </div>
            )}
        </div>
    </div>
</div> */}


{/* Initial ticket info */}
{/* <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg">
    <div className="flex items-start">
        <MessageSquare className="w-5 h-5 text-blue-600 mt-0.5 mr-3" />
        <div className="flex-1">
            <p className="text-sm font-medium text-blue-900">Original Issue</p>
            <p className="text-sm text-blue-800 mt-1">{ticket.comment}</p>
            <p className="text-xs text-blue-600 mt-2">
                Order: {ticket.orderIdOrAwb}
            </p>
            
            {ticket.attachedFiles && ticket.attachedFiles.length > 0 && (
                <div className="mt-3 space-y-2">
                    <p className="text-xs text-blue-900 font-medium">Attachments:</p>
                    {ticket.attachedFiles.map((file, index) => (
                        <div key={index}>
                            {(() => {
                                const fileExtension = file.name ? 
                                    file.name.split('.').pop().toLowerCase() : '';
                                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
                                const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);
                                
                                if (isImage) {
                                    return (
                                        <img 
                                            src={file.url} 
                                            alt={file.name}
                                            className="rounded-lg max-w-xs h-auto cursor-pointer hover:opacity-90"
                                            onClick={() => window.open(file.url, '_blank')}
                                        />
                                    );
                                } else if (isVideo) {
                                    return (
                                        <video 
                                            controls 
                                            className="rounded-lg max-w-xs h-auto"
                                            preload="metadata"
                                        >
                                            <source src={file.url} type={`video/${fileExtension}`} />
                                        </video>
                                    );
                                } else {
                                    return (
                                        <a 
                                            href={file.url} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="text-sm text-blue-700 hover:text-blue-900 flex items-center"
                                        >
                                            📎 {file.name}
                                        </a>
                                    );
                                }
                            })()}
                        </div>
                    ))}
                </div>
            )}
            
            {ticket.attachedFileUrl && !ticket.attachedFiles && (
                <div className="mt-3">
                    {(() => {
                        const fileExtension = ticket.attachedFileName ? 
                            ticket.attachedFileName.split('.').pop().toLowerCase() : '';
                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
                        const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);
                        
                        if (isImage) {
                            return (
                                <img 
                                    src={ticket.attachedFileUrl} 
                                    alt={ticket.attachedFileName}
                                    className="rounded-lg max-w-xs h-auto cursor-pointer hover:opacity-90"
                                    onClick={() => window.open(ticket.attachedFileUrl, '_blank')}
                                />
                            );
                        } else if (isVideo) {
                            return (
                                <video 
                                    controls 
                                    className="rounded-lg max-w-xs h-auto"
                                    preload="metadata"
                                >
                                    <source src={ticket.attachedFileUrl} type={`video/${fileExtension}`} />
                                </video>
                            );
                        } else {
                            return (
                                <a 
                                    href={ticket.attachedFileUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-sm text-blue-700 hover:text-blue-900 flex items-center"
                                >
                                    📎 {ticket.attachedFileName || 'View Attachment'}
                                </a>
                            );
                        }
                    })()}
                </div>
            )}
        </div>
    </div>
</div> */}

                            {/* Chat Messages */}
{messages.map((message) => (
    <div key={message.id} className={`flex ${message.senderType === userType ? 'justify-end' : 'justify-start'}`}>
        <div className={`max-w-xs lg:max-w-md px-4 py-3 rounded-lg ${
            message.senderType === userType
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-900 shadow-sm border'
        }`}>
            {message.isInitial && (
                <div className="text-xs font-medium mb-2 opacity-75">
                    Original Ticket
                </div>
            )}
            <div className="flex items-center space-x-2 mb-1">
                {message.senderType === 'admin' ? (
                    <Headphones className="w-4 h-4" />
                ) : (
                    <User className="w-4 h-4" />
                )}
                <span className="text-xs font-medium">
                    {message.senderName}
                </span>
            </div>
            {message.message && <p className="text-sm whitespace-pre-wrap">{message.message}</p>}
            
            {/* Handle multiple attachedFiles in messages */}
            {message.attachedFiles && message.attachedFiles.length > 0 && (
                <div className="mt-2 space-y-2">
                    {message.attachedFiles.map((file, fileIndex) => (
                        <div key={fileIndex}>
                            {(() => {
                                const fileExtension = file.name ? 
                                    file.name.split('.').pop().toLowerCase() : '';
                                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
                                const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);
                                const isPdf = fileExtension === 'pdf';
                                
                                if (isImage) {
                                    return (
                                        <div className="max-w-xs">
                                            <img 
                                                src={file.url} 
                                                alt={file.name}
                                                className="rounded-lg max-w-full h-auto cursor-pointer hover:opacity-90"
                                                onClick={() => window.open(file.url, '_blank')}
                                            />
                                        </div>
                                    );
                                } else if (isVideo) {
                                    return (
                                        <div className="max-w-xs">
                                            <video 
                                                controls 
                                                className="rounded-lg max-w-full h-auto"
                                                preload="metadata"
                                            >
                                                <source src={file.url} type={`video/${fileExtension}`} />
                                            </video>
                                        </div>
                                    );
                                } else if (isPdf) {
                                    return (
                                        <div className={`flex items-center p-2 rounded border ${
                                            message.senderType === userType ? 'border-blue-300 bg-blue-500' : 'border-gray-300 bg-gray-50'
                                        }`}>
                                            <div className="text-red-600 mr-2">📄</div>
                                            <div className="flex-1 min-w-0">
                                                <p className={`text-xs font-medium truncate ${
                                                    message.senderType === userType ? 'text-white' : 'text-gray-900'
                                                }`}>
                                                    {file.name}
                                                </p>
                                            </div>
                                            <button
                                                onClick={() => window.open(file.url, '_blank')}
                                                className={`text-xs px-2 py-1 rounded ml-2 ${
                                                    message.senderType === userType 
                                                        ? 'bg-blue-400 text-white hover:bg-blue-300' 
                                                        : 'bg-blue-600 text-white hover:bg-blue-700'
                                                }`}
                                            >
                                                Open
                                            </button>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <a 
                                            href={file.url} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className={`text-xs flex items-center hover:underline ${
                                                message.senderType === userType ? 'text-blue-100' : 'text-blue-600'
                                            }`}
                                        >
                                            📎 {file.name}
                                        </a>
                                    );
                                }
                            })()}
                        </div>
                    ))}
                </div>
            )}

            {/* Legacy support for single attachedFileUrl in messages */}
            {message.attachedFileUrl && !message.attachedFiles && (
                <div className="mt-2">
                    {(() => {
                        const fileExtension = message.attachedFileName ? 
                            message.attachedFileName.split('.').pop().toLowerCase() : '';
                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
                        const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);
                        const isPdf = fileExtension === 'pdf';
                        
                        if (isImage) {
                            return (
                                <div className="max-w-xs">
                                    <img 
                                        src={message.attachedFileUrl} 
                                        alt={message.attachedFileName}
                                        className="rounded-lg max-w-full h-auto cursor-pointer hover:opacity-90"
                                        onClick={() => window.open(message.attachedFileUrl, '_blank')}
                                    />
                                </div>
                            );
                        } else if (isVideo) {
                            return (
                                <div className="max-w-xs">
                                    <video 
                                        controls 
                                        className="rounded-lg max-w-full h-auto"
                                        preload="metadata"
                                    >
                                        <source src={message.attachedFileUrl} type={`video/${fileExtension}`} />
                                    </video>
                                </div>
                            );
                        } else if (isPdf) {
                            return (
                                <div className={`flex items-center p-2 rounded border ${
                                    message.senderType === userType ? 'border-blue-300 bg-blue-500' : 'border-gray-300 bg-gray-50'
                                }`}>
                                    <div className="text-red-600 mr-2">📄</div>
                                    <div className="flex-1 min-w-0">
                                        <p className={`text-xs font-medium truncate ${
                                            message.senderType === userType ? 'text-white' : 'text-gray-900'
                                        }`}>
                                            {message.attachedFileName}
                                        </p>
                                    </div>
                                    <button
                                        onClick={() => window.open(message.attachedFileUrl, '_blank')}
                                        className={`text-xs px-2 py-1 rounded ml-2 ${
                                            message.senderType === userType 
                                                ? 'bg-blue-400 text-white hover:bg-blue-300' 
                                                : 'bg-blue-600 text-white hover:bg-blue-700'
                                        }`}
                                    >
                                        Open
                                    </button>
                                </div>
                            );
                        } else {
                            return (
                                <a 
                                    href={message.attachedFileUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={`text-xs flex items-center hover:underline ${
                                        message.senderType === userType ? 'text-blue-100' : 'text-blue-600'
                                    }`}
                                >
                                    📎 {message.attachedFileName || 'Attachment'}
                                </a>
                            );
                        }
                    })()}
                </div>
            )}
            
            <p className={`text-xs mt-1 ${
                message.senderType === userType ? 'text-blue-100' : 'text-gray-500'
            }`}>
                {formatDate(message.createdAt)}
            </p>
        </div>
    </div>
))}
                            <div ref={messagesEndRef} />
                        </>
                    )}
                </div>


                {!isViewOnly && (
    <div className="border-t bg-white p-4 rounded-b-lg">
        {/* File attachment preview */}
        {selectedFile && (
            <div className="mb-3 p-2 bg-gray-50 rounded-lg border">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                        <span className="text-gray-500">📎</span>
                        <span className="text-sm text-gray-700">{selectedFile.name}</span>
                        <span className="text-xs text-gray-500">
                            ({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)
                        </span>
                    </div>
                    <button
                        type="button"
                        onClick={removeSelectedFile}
                        className="text-red-500 hover:text-red-700 text-sm"
                    >
                        Remove
                    </button>
                </div>
            </div>
        )}
        
        <div className="flex items-end space-x-2">
            <div className="flex-1">
                <textarea
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type your message..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                    disabled={sending}
                    maxLength={500}
                    rows={3}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            sendMessage(e);
                        }
                    }}
                />
                <p className="text-xs text-gray-500 mt-1">
                    {newMessage.length}/500 characters
                </p>
            </div>
            
            <div className="flex flex-col space-y-2">
                {/* File attach button */}
                <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    disabled={sending}
                    className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 disabled:opacity-50"
                >
                    📎
                </button>
                
                {/* Send button */}
                <button
                    type="button"
                    onClick={sendMessage}
                    disabled={(!newMessage.trim() && !selectedFile) || sending}
                    className="w-10 h-10 flex items-center justify-center bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {sending ? (
                        <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                    ) : (
                        <Send className="w-4 h-4" />
                    )}
                </button>
            </div>
        </div>

        {/* Hidden file input */}
        <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileSelect}
            className="hidden"
            accept=".jpg,.jpeg,.png,.gif,.pdf,.txt,.doc,.docx,.mp4,.webm,.mp3,.wav"
        />
    </div>
)}
            </div>
        </div>
    );
};

export default ChatModal;